export default __webpack_public_path__ + "static/media/gallery_19.b885f374.jpg";